import { useState, useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { showAuthLoader, hideAuthLoader } from '../appRedux/actions';
import Service from '../service';

/**
 * Custom hook to fetch and manage branch list with pagination and search
 *
 * @param {Object} [options]
 * @param {boolean} [options.enabled=true] fetch on mount. Pass false to hold the
 *   request back (e.g. until a filter modal is first opened); the fetch runs as
 *   soon as it flips to true.
 * @param {boolean} [options.showLoader=true] cover the page with the global loader
 *   while fetching. Background fetches for data that is not needed to paint the
 *   page should pass false.
 */
export default function useBranchList({ enabled = true, showLoader = true } = {}) {
    const dispatch = useDispatch();
    const [branchList, setBranchList] = useState([]);


    const fetchBranches = useCallback(async () => {
        try {
            if (showLoader) dispatch(showAuthLoader());


            const response = await Service.makeAPICall({
                methodName: Service.postMethod,
                api_url: Service.getBranchList,

            });

            if (response.data?.data) {
                setBranchList(response.data.data);

            }
        } catch (error) {
            console.error('Failed to fetch branches', error);
        } finally {
            if (showLoader) dispatch(hideAuthLoader());
        }
    }, [dispatch, showLoader]);

    // auto-fetch when pagination or searchText changes
    useEffect(() => {
        if (!enabled) return;
        fetchBranches();
    }, [fetchBranches, enabled]);


    return {
        branchList,
        loading: false, // you can derive this from store if needed
        fetchBranches,

    };
}
